module.exports = __webpack_public_path__ + "assets/img/zh-Hant-917a2a0f.png";